import { createSlice } from "@reduxjs/toolkit";
import {
  showEnumSetting,
  showLookupSetting,
  showScreenSetting,
  showCommonSetting,
  showNavigationSetting,
  showEmailSetting,
  showHomeSetting,
  showDictionarySetting,
} from "../actions";

const initialState = {
  enumSetting: [],
  lookup: [],
  screen: [],
  common: [],
  navigationSetting: [],
  emailSetting: [],
  homeSetting: [],
  dictionarySetting: [],
};

const settingSlice = createSlice({
  name: "setting",
  initialState,
  extraReducers: {
    [showEnumSetting.fulfilled]: (state, action) => {
      state.enumSetting = action.payload || [];
    },
    [showLookupSetting.fulfilled]: (state, action) => {
      state.lookup = action.payload || [];
    },
    [showScreenSetting.fulfilled]: (state, action) => {
      state.screen = action.payload || [];
    },
    [showCommonSetting.fulfilled]: (state, action) => {
      state.common = action.payload || [];
    },
    [showNavigationSetting.fulfilled]: (state, action) => {
      state.navigationSetting = action.payload || [];
    },
    [showEmailSetting.fulfilled]: (state, action) => {
      state.emailSetting = action.payload || [];
    },
    [showHomeSetting.fulfilled]: (state, action) => {
      state.homeSetting = action.payload || [];
    },
    [showDictionarySetting.fulfilled]: (state, action) => {
      state.dictionarySetting = action.payload || [];
    },
  },
});

export const responseSetting = (state) => state.setting;

export default settingSlice.reducer;
